//@ts-nocheck

function parseXml(xmlString) {
    const parser = new DOMParser();
    return parser.parseFromString(xmlString, "text/xml");
  }
  
  function jsonToXml(jsonObject, elementName, existingDoc) {
    elementName = elementName ?? "root";
    const doc =
      existingDoc ?? parseXml("<" + elementName + "></" + elementName + ">");
  
    function convertType(jsonObject, element) {
      if (jsonObject === null) {
        element.setAttribute("type", "null");
        return true;
      }
      switch (typeof jsonObject) {
        case "object":
          if (jsonObject instanceof Array) jsonArrayToXml(jsonObject, element);
          else jsonObjectToXml(jsonObject, element);
          break;
  
        case "string":
          element.setAttribute("type", "string");
          element.appendChild(doc.createTextNode(jsonObject));
          break;
  
        case "bigint":
        case "number":
          element.setAttribute("type", "number");
          element.appendChild(doc.createTextNode("" + jsonObject));
          break;
  
        case "boolean":
          element.setAttribute("type", "boolean");
          element.appendChild(doc.createTextNode(jsonObject ? "Y" : "N"));
          break;
        default:
          return false;
      }
  
      return true;
    }
  
    function jsonArrayToXml(jsonObject, element) {
      element.setAttribute("type", "array");
  
      for (let i = 0; i < jsonObject.length; i++) {
        const child = jsonObject[i];
        const childEl = doc.createElement("item");
  
        if (!convertType(child, childEl)) childEl.setAttribute("type", "null");
  
        element.appendChild(childEl);
      }
    }
  
    function jsonObjectToXml(jsonObject, element) {
      element.setAttribute("type", "object");
  
      for (const name in jsonObject) {
        if (!Object.hasOwnProperty.call(jsonObject, name)) continue;
  
        const child = jsonObject[name];
        const childEl = doc.createElement(name);
  
        if (!convertType(child, childEl)) continue;
  
        element.appendChild(childEl);
      }
    }
  
    const root =
      existingDoc !== undefined
        ? existingDoc.createElement(elementName)
        : doc.firstElementChild;
  
    if (!convertType(jsonObject, root)) root.setAttribute("type", "null");
  
    return existingDoc !== undefined ? root : doc;
  }
  
  function formatXml(xmlDoc) {
    var xsltDoc = new DOMParser().parseFromString(
      [
        '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
        '  <xsl:strip-space elements="*"/>',
        '  <xsl:template match="para[content-style][not(text())]">',
        '    <xsl:value-of select="normalize-space(.)"/>',
        "  </xsl:template>",
        '  <xsl:template match="node()|@*">',
        '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
        "  </xsl:template>",
        '  <xsl:output indent="yes"/>',
        "</xsl:stylesheet>",
      ].join("\n"),
      "application/xml"
    );
  
    var xsltProcessor = new XSLTProcessor();
    xsltProcessor.importStylesheet(xsltDoc);
    var resultDoc = xsltProcessor.transformToDocument(xmlDoc);
    var resultXml = new XMLSerializer().serializeToString(resultDoc);
    return resultXml;
  }
  
  const XLSTResultType = {
    Xml: 0,
    Json: 1,
    Text: 2,
  };
  
  class XLSTTransform {
    #processor;
    #resultType;
  
    constructor(encodedText, type) {
      const text = atob(encodedText);
      this.#resultType = type ?? XLSTResultType.Xml;
      const xml = parseXml(text);
      this.#processor = new XSLTProcessor();
  
      this.#processor.importStylesheet(xml);
    }
  
    #processXml(xmlDoc) {
      try {
        const doc = this.#processor.transformToDocument(xmlDoc);
        return doc;
      } catch (e) {
        return null;
      }
    }
  
    #processJson(doc) {
      try {
        const docText = doc.documentElement.innerText;
        return JSON.parse(docText);
      } catch (e) {
        return null;
      }
    }
  
    process(xmlDoc) {
      const doc = this.#processXml(xmlDoc);
  
      if (doc == null) return [false, "xml"];
  
      switch (this.#resultType) {
        case XLSTResultType.Xml:
          return [true, doc];
        case XLSTResultType.Text:
          return [true, doc.innerText];
        case XLSTResultType.Json:
          const json = this.#processJson(doc);
  
          if (json == null) return [false, "json"];
  
          return [true, json];
      }
    }
  }
  
  const ErrorCode = {
    NONE: "",
    HTTP_ERROR: "Unable to process request",
    XML_ERROR: "Failed to process XML data",
    JSON_ERROR: "Failed to parse JSON data",
    REQUEST_FAILED: "Request failed on server",
    PARTIAL_DATA: "Some data is not available",
    PROFILE_CHANGED: "The profile has changed on server",
    UNKNOWN_ERROR: "An unknown error has occurred",
  };
  
  const BalanceType = {
    Comp: "Comp",
    SecondComp: "SecondComp",
    XtraCredit: "XtraCredit",
    Points: "Points",
  };
  
  const BalanceAdjustimentType = {
    Credit: "C",
    Debit: "D",
  };
  
  export class UniversalConnector {
    #url;
  
    #getPatronProfileXLST = new XLSTTransform(
      "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",
      XLSTResultType.Json
    );
    #getPlayerActivityXSLT = new XLSTTransform(
      "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",
      XLSTResultType.Json
    );
    #updateProfileXSLT = new XLSTTransform(
      "PHhzbDp0cmFuc2Zvcm0geG1sbnM6eHNsPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L1hTTC9UcmFuc2Zvcm0iIHZlcnNpb249IjEuMCI+CiAgPHhzbDp0ZW1wbGF0ZSBtYXRjaD0iLyI+ICAKICAgIDx4c2w6YXBwbHktdGVtcGxhdGVzLz4KICA8L3hzbDp0ZW1wbGF0ZT4KICAgIAogIDx4c2w6dGVtcGxhdGUgbmFtZT0iQm9vbENvbnZlcnQiPgogICAgPHhzbDpwYXJhbSBuYW1lPSJ2YWx1ZSIvPgogICAgPHhzbDpwYXJhbSBuYW1lPSJ3aGVuVHJ1ZSIvPgogICAgPHhzbDpwYXJhbSBuYW1lPSJ3aGVuRmFsc2UiLz4KICAgIDx4c2w6Y2hvb3NlPgogICAgICA8eHNsOndoZW4gdGVzdD0iJHZhbHVlID0gJ1knIj48eHNsOnZhbHVlLW9mIHNlbGVjdCA9IiR3aGVuVHJ1ZSIvPjwveHNsOndoZW4+CiAgICAgIDx4c2w6b3RoZXJ3aXNlPjx4c2w6dmFsdWUtb2Ygc2VsZWN0ID0iJHdoZW5GYWxzZSIvPjwveHNsOm90aGVyd2lzZT4KICAgIDwveHNsOmNob29zZT4gICAgCiAgPC94c2w6dGVtcGxhdGU+CiAgCiAgPHhzbDp0ZW1wbGF0ZSBtYXRjaD0icm9vdCI+ICAKPENSTUFjcmVzTWVzc2FnZT4KICA8SGVhZGVyPgogICAgPE1lc3NhZ2VJRD48eHNsOnZhbHVlLW9mIHNlbGVjdD0ibWVzc2FnZUlkIi8+PC9NZXNzYWdlSUQ+CiAgPC9IZWFkZXI+CiAgPEJvZHk+CiAgICA8eHNsOmZvci1lYWNoIHNlbGVjdD0iYWRkcmVzcyI+CiAgICAgIDxBZGRyZXNzPgogICAgICAgIDxBZGRyZXNzMT4KICAgICAgICAgIDx4c2w6dmFsdWUtb2Ygc2VsZWN0PSJhZGRyZXNzMSIvPgogICAgICAgIDwvQWRkcmVzczE+CiAgICAgICAgPEFkZHJlc3MyPgogICAgICAgICAgPHhzbDp2YWx1ZS1vZiBzZWxlY3Q9ImFkZHJlc3MyIi8+CiAgICAgICAgPC9BZGRyZXNzMj4KICAgICAgICA8Q2l0eT4KICAgICAgICAgIDx4c2w6dmFsdWUtb2Ygc2VsZWN0PSJjaXR5Ii8+CiAgICAgICAgPC9DaXR5PgogICAgICAgIDxTdGF0ZVByb3ZpbmNlPgogICAgICAgICAgPHhzbDp2YWx1ZS1vZiBzZWxlY3Q9InN0YXRlIi8+CiAgICAgICAgPC9TdGF0ZVByb3ZpbmNlPgogICAgICAgIDxQb3N0YWxDb2RlPgogICAgICAgICAgPHhzbDp2YWx1ZS1vZiBzZWxlY3Q9InppcENvZGUiLz4KICAgICAgICA8L1Bvc3RhbENvZGU+CiAgICAgICAgPENvdW50cnk+CiAgICAgICAgICA8eHNsOnZhbHVlLW9mIHNlbGVjdD0iY291bnRyeSIvPgogICAgICAgIDwvQ291bnRyeT4KICAgICAgICA8TG9jYXRpb24+CiAgICAgICAgICA8eHNsOnZhbHVlLW9mIHNlbGVjdD0ibG9jYXRpb24iLz4KICAgICAgICA8L0xvY2F0aW9uPgogICAgICAgIDxEZWxpdmVyYWJsZT4KICAgICAgICAgIDx4c2w6Y2FsbC10ZW1wbGF0ZSBuYW1lPSJCb29sQ29udmVydCI+CiAgICAgICAgICAgIDx4c2w6d2l0aC1wYXJhbSBuYW1lPSJ2YWx1ZSIgc2VsZWN0PSJkZWxpdmVyYWJsZSIvPgogICAgICAgICAgICA8eHNsOndpdGgtcGFyYW0gbmFtZT0id2hlbkZhbHNlIj5mYWxzZTwveHNsOndpdGgtcGFyYW0+CiAgICAgICAgICAgIDx4c2w6d2l0aC1wYXJhbSBuYW1lPSJ3aGVuVHJ1ZSI+dHJ1ZTwveHNsOndpdGgtcGFyYW0+CiAgICAgICAgICA8L3hzbDpjYWxsLXRlbXBsYXRlPgogICAgICAgIDwvRGVsaXZlcmFibGU+CiAgICAgICAgPFByZWZlcnJlZD4KICAgICAgICAgIDx4c2w6Y2FsbC10ZW1wbGF0ZSBuYW1lPSJCb29sQ29udmVydCI+CiAgICAgICAgICAgIDx4c2w6d2l0aC1wYXJhbSBuYW1lPSJ2YWx1ZSIgc2VsZWN0PSJwcmVmZXJyZWQiLz4KICAgICAgICAgICAgPHhzbDp3aXRoLXBhcmFtIG5hbWU9IndoZW5GYWxzZSI+ZmFsc2U8L3hzbDp3aXRoLXBhcmFtPgogICAgICAgICAgICA8eHNsOndpdGgtcGFyYW0gbmFtZT0id2hlblRydWUiPnRydWU8L3hzbDp3aXRoLXBhcmFtPgogICAgICAgICAgPC94c2w6Y2FsbC10ZW1wbGF0ZT4KICAgICAgICA8L1ByZWZlcnJlZD4KICAgICAgPC9BZGRyZXNzPgogICAgPC94c2w6Zm9yLWVhY2g+CiAgICA8eHNsOmZvci1lYWNoIHNlbGVjdD0icGhvbmVOdW1iZXIiPgogICAgICA8UGhvbmVOdW1iZXI+CiAgICAgICAgPE51bWJlcj4KICAgICAgICAgIDx4c2w6dmFsdWUtb2Ygc2VsZWN0PSJudW1iZXIiLz4KICAgICAgICA8L051bWJlcj4KICAgICAgICA8TG9jYXRpb24+CiAgICAgICAgICA8eHNsOnZhbHVlLW9mIHNlbGVjdD0ibG9jYXRpb24iLz4KICAgICAgICA8L0xvY2F0aW9uPgogICAgICAgIDxQcmVmZXJyZWQ+CiAgICAgICAgICA8eHNsOmNhbGwtdGVtcGxhdGUgbmFtZT0iQm9vbENvbnZlcnQiPgogICAgICAgICAgICA8eHNsOndpdGgtcGFyYW0gbmFtZT0idmFsdWUiIHNlbGVjdD0icHJlZmVycmVkIi8+CiAgICAgICAgICAgIDx4c2w6d2l0aC1wYXJhbSBuYW1lPSJ3aGVuRmFsc2UiPmZhbHNlPC94c2w6d2l0aC1wYXJhbT4KICAgICAgICAgICAgPHhzbDp3aXRoLXBhcmFtIG5hbWU9IndoZW5UcnVlIj50cnVlPC94c2w6d2l0aC1wYXJhbT4KICAgICAgICAgIDwveHNsOmNhbGwtdGVtcGxhdGU+CiAgICAgICAgPC9QcmVmZXJyZWQ+CiAgICAgICAgPFBlcm1pdFRleHRNc2c+CiAgICAgICAgICA8eHNsOnZhbHVlLW9mIHNlbGVjdD0icGVybWl0VGV4dE1zZyIvPgogICAgICAgIDwvUGVybWl0VGV4dE1zZz4KICAgICAgPC9QaG9uZU51bWJlcj4KICAgIDwveHNsOmZvci1lYWNoPgogICAgPHhzbDpmb3ItZWFjaCBzZWxlY3Q9ImVtYWlsIj4KICAgICAgPEVtYWlsPgogICAgICAgIDxBZGRyZXNzPgogICAgICAgICAgPHhzbDp2YWx1ZS1vZiBzZWxlY3Q9ImFkZHJlc3MiLz4KICAgICAgICA8L0FkZHJlc3M+CiAgICAgICAgPExvY2F0aW9uPgogICAgICAgICAgPHhzbDp2YWx1ZS1vZiBzZWxlY3Q9ImxvY2F0aW9uIi8+CiAgICAgICAgPC9Mb2NhdGlvbj4KICAgICAgICA8UHJlZmVycmVkPgogICAgICAgICAgPHhzbDpjYWxsLXRlbXBsYXRlIG5hbWU9IkJvb2xDb252ZXJ0Ij4KICAgICAgICAgICAgPHhzbDp3aXRoLXBhcmFtIG5hbWU9InZhbHVlIiBzZWxlY3Q9InByaW1hcnkiLz4KICAgICAgICAgICAgPHhzbDp3aXRoLXBhcmFtIG5hbWU9IndoZW5GYWxzZSI+ZmFsc2U8L3hzbDp3aXRoLXBhcmFtPgogICAgICAgICAgICA8eHNsOndpdGgtcGFyYW0gbmFtZT0id2hlblRydWUiPnRydWU8L3hzbDp3aXRoLXBhcmFtPgogICAgICAgICAgPC94c2w6Y2FsbC10ZW1wbGF0ZT4KICAgICAgICA8L1ByZWZlcnJlZD4KICAgICAgPC9FbWFpbD4KICAgIDwveHNsOmZvci1lYWNoPgogIDwvQm9keT4KPC9DUk1BY3Jlc01lc3NhZ2U+CiA8L3hzbDp0ZW1wbGF0ZT4KPC94c2w6dHJhbnNmb3JtPg==",
      XLSTResultType.Xml
    );
    #getPlayerBalancesXSLT = new XLSTTransform(
      "PHhzbDp0cmFuc2Zvcm0geG1sbnM6eHNsPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L1hTTC9UcmFuc2Zvcm0iIHZlcnNpb249IjEuMCI+CiAgPHhzbDp0ZW1wbGF0ZSBtYXRjaD0iLyI+CiAgICA8eHNsOmFwcGx5LXRlbXBsYXRlcyBzZWxlY3Q9IkNSTUFjcmVzTWVzc2FnZS9Cb2R5L1BsYXllckJhbGFuY2VzIi8+CiAgPC94c2w6dGVtcGxhdGU+CiAgCiAgPHhzbDp0ZW1wbGF0ZSBtYXRjaD0iUGxheWVyQmFsYW5jZXMiPgogICAgewogICAgICAicmV3YXJkQmFsYW5jZSI6IDx4c2w6dmFsdWUtb2Ygc2VsZWN0PSJSZXdhcmRCYWxhbmNlIi8+LAogICAgICAiY29tcEJhbGFuY2UiOiA8eHNsOnZhbHVlLW9mIHNlbGVjdD0iQ29tcEJhbGFuY2UiLz4sCiAgICAgICJzZWNvbmRDb21wQmFsYW5jZSI6IDx4c2w6dmFsdWUtb2Ygc2VsZWN0PSJTZWNvbmRDb21wQmFsYW5jZSIvPiwKICAgICAgImdpZnRQb2ludHMiOiA8eHNsOnZhbHVlLW9mIHNlbGVjdD0iR2lmdFBvaW50cyIvPiwKICAgICAgInh0cmFDcmVkaXRCYWxhbmNlTG9jYWwiOiA8eHNsOnZhbHVlLW9mIHNlbGVjdD0iWHRyYUNyZWRpdEJhbGFuY2VMb2NhbCIvPiwKICAgICAgInh0cmFDcmVkaXRCYWxhbmNlR2xvYmFsIjogPHhzbDp2YWx1ZS1vZiBzZWxlY3Q9Ilh0cmFDcmVkaXRCYWxhbmNlR2xvYmFsIi8+LAogICAgICAicG9pbnRCYWxhbmNlIjogPHhzbDp2YWx1ZS1vZiBzZWxlY3Q9IlBvaW50QmFsYW5jZSIvPgogICAgfQogIDwveHNsOnRlbXBsYXRlPgogIDx4c2w6b3V0cHV0IG1ldGhvZD0idGV4dCIgaW5kZW50PSJ5ZXMiLz4KPC94c2w6dHJhbnNmb3JtPg==",
      XLSTResultType.Json
    );
    #doBalanceAdjustmentXSLT = new XLSTTransform(
      "PHhzbDp0cmFuc2Zvcm0geG1sbnM6eHNsPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L1hTTC9UcmFuc2Zvcm0iIHZlcnNpb249IjEuMCI+CiAgPHhzbDp0ZW1wbGF0ZSBtYXRjaD0iLyI+ICAKICAgIDx4c2w6YXBwbHktdGVtcGxhdGVzLz4KICA8L3hzbDp0ZW1wbGF0ZT4KICAgIAogIDx4c2w6dGVtcGxhdGUgbmFtZT0iQm9vbENvbnZlcnQiPgogICAgPHhzbDpwYXJhbSBuYW1lPSJ2YWx1ZSIvPgogICAgPHhzbDpwYXJhbSBuYW1lPSJ3aGVuVHJ1ZSIvPgogICAgPHhzbDpwYXJhbSBuYW1lPSJ3aGVuRmFsc2UiLz4KICAgIDx4c2w6Y2hvb3NlPgogICAgICA8eHNsOndoZW4gdGVzdD0iJHZhbHVlID0gJ1knIj48eHNsOnZhbHVlLW9mIHNlbGVjdCA9IiR3aGVuVHJ1ZSIvPjwveHNsOndoZW4+CiAgICAgIDx4c2w6b3RoZXJ3aXNlPjx4c2w6dmFsdWUtb2Ygc2VsZWN0ID0iJHdoZW5GYWxzZSIvPjwveHNsOm90aGVyd2lzZT4KICAgIDwveHNsOmNob29zZT4gICAgCiAgPC94c2w6dGVtcGxhdGU+CiAgCiAgPHhzbDp0ZW1wbGF0ZSBtYXRjaD0icm9vdCI+ICAKPENSTUFjcmVzTWVzc2FnZT4KICA8SGVhZGVyPgogICAgPE1lc3NhZ2VJRD48eHNsOnZhbHVlLW9mIHNlbGVjdD0ibWVzc2FnZUlkIi8+PC9NZXNzYWdlSUQ+CiAgPC9IZWFkZXI+CiAgPEJvZHk+CiAgICA8QmFsYW5jZVR5cGU+PHhzbDp2YWx1ZS1vZiBzZWxlY3Q9ImJhbGFuY2VUeXBlIi8+PC9CYWxhbmNlVHlwZT4KICAgIDxDcmVkaXQ+PHhzbDp2YWx1ZS1vZiBzZWxlY3Q9ImNyZWRpdFR5cGUiLz48L0NyZWRpdD4KICAgIDxWYWx1ZT48eHNsOnZhbHVlLW9mIHNlbGVjdD0idmFsdWUiLz48L1ZhbHVlPgogIDwvQm9keT4KPC9DUk1BY3Jlc01lc3NhZ2U+CiA8L3hzbDp0ZW1wbGF0ZT4KPC94c2w6dHJhbnNmb3JtPg==",
      XLSTResultType.Xml
    );
    #balanceAdjustmentXSLT = new XLSTTransform(
      "PHhzbDp0cmFuc2Zvcm0geG1sbnM6eHNsPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L1hTTC9UcmFuc2Zvcm0iIHZlcnNpb249IjEuMCI+CiAgPHhzbDp0ZW1wbGF0ZSBtYXRjaD0iLyI+CiAgICA8eHNsOmFwcGx5LXRlbXBsYXRlcyBzZWxlY3Q9IkNSTUFjcmVzTWVzc2FnZS9Cb2R5L1BsYXllckJhbGFuY2VBZGp1c3RtZW50Ii8+CiAgPC94c2w6dGVtcGxhdGU+CiAgCiAgPHhzbDp0ZW1wbGF0ZSBtYXRjaD0iUGxheWVyQmFsYW5jZUFkanVzdG1lbnQiPgogICAgeyAgICAgIAogICAgICAiYmFsYW5jZVR5cGUiOiAiPHhzbDp2YWx1ZS1vZiBzZWxlY3Q9IkJhbGFuY2VUeXBlIi8+IiwKICAgICAgImNyZWRpdE9yRGViaXQiOiAiPHhzbDp2YWx1ZS1vZiBzZWxlY3Q9IkNyZWRpdE9yRGViaXQiLz4iLAogICAgICAiYW1vdW50IjogPHhzbDp2YWx1ZS1vZiBzZWxlY3Q9IkFtb3VudCIvPiwKICAgICAgImJhbGFuY2VzIjogewogICAgICA8eHNsOmNob29zZT4KICAgICAgICA8eHNsOndoZW4gdGVzdD0iQmFsYW5jZVR5cGU9J1h0cmFDcmVkaXQnIj4KICAgICAgICAgICAgIm9sZCI6PHhzbDp2YWx1ZS1vZiBzZWxlY3Q9Ik9sZFh0cmFDcmVkaXRCYWxhbmNlIi8+LAogICAgICAgICAgICAibmV3Ijo8eHNsOnZhbHVlLW9mIHNlbGVjdD0iTmV3WHRyYUNyZWRpdEJhbGFuY2UiLz4KICAgICAgICA8L3hzbDp3aGVuPgogICAgICAgIDx4c2w6d2hlbiB0ZXN0PSJCYWxhbmNlVHlwZT0nUG9pbnRzJyI+CiAgICAgICAgICAib2xkIjo8eHNsOnZhbHVlLW9mIHNlbGVjdD0iT2xkUG9pbnRCYWxhbmNlIi8+LAogICAgICAgICAgIm5ldyI6PHhzbDp2YWx1ZS1vZiBzZWxlY3Q9Ik5ld1BvaW50QmFsYW5jZSIvPgogICAgICAgIDwveHNsOndoZW4+CiAgICAgICAgPHhzbDp3aGVuIHRlc3Q9IkJhbGFuY2VUeXBlPSdDb21wJyI+CiAgICAgICAgICAib2xkIjo8eHNsOnZhbHVlLW9mIHNlbGVjdD0iT2xkQ29tcEJhbGFuY2UiLz4sCiAgICAgICAgICAibmV3Ijo8eHNsOnZhbHVlLW9mIHNlbGVjdD0iTmV3Q29tcEJhbGFuY2UiLz4KICAgICAgICA8L3hzbDp3aGVuPgogICAgICAgIDx4c2w6d2hlbiB0ZXN0PSJCYWxhbmNlVHlwZT0nU2Vjb25kQ29tcCciPgogICAgICAgICAgIm9sZCI6PHhzbDp2YWx1ZS1vZiBzZWxlY3Q9Ik9sZFNlY29uZENvbXBCYWxhbmNlIi8+LAogICAgICAgICAgIm5ldyI6PHhzbDp2YWx1ZS1vZiBzZWxlY3Q9Ik5ld1NlY29uZENvbXBCYWxhbmNlIi8+CiAgICAgICAgPC94c2w6d2hlbj4KICAgICAgPC94c2w6Y2hvb3NlPgogICAgICB9CiAgICB9CiAgPC94c2w6dGVtcGxhdGU+CiAgPHhzbDpvdXRwdXQgbWV0aG9kPSJ0ZXh0IiBpbmRlbnQ9InllcyIvPgo8L3hzbDp0cmFuc2Zvcm0+",
      XLSTResultType.Json
    );
    static nextMessageId = Math.round(Math.random() * 1000);
  
    constructor(url) {
      this.#url = url;
    }
  
    async #getRequest(path) {
      const response = await fetch(this.#url + path);
      if (response.status != 200)
        return [
          ErrorCode.HTTP_ERROR,
          response.status + " " + response.statusText,
        ];
  
      const text = await response.text();
  
      const source = parseXml(text);
      const nsr = source.createNSResolver(source.documentElement);
  
      let find = source.evaluate(
        "/CRMAcresMessage/Body/Error",
        source.documentElement,
        nsr,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null
      );
      if (find.singleNodeValue !== null) {
        find = source.evaluate(
          "/CRMAcresMessage/Body/Error/ErrorDescription",
          source.documentElement,
          nsr,
          XPathResult.STRING_TYPE,
          find
        );
        return [ErrorCode.REQUEST_FAILED, find.stringValue];
      }
  
      return [ErrorCode.NONE, source];
    }
  
    async #postRequest(path, content) {
      const response = await fetch(this.#url + path, {
        method: "POST",
        //mode: "no-cors",
        //credentials: "same-origin",
        headers: {
          "Content-Type": "application/xml",
        },
        body: new XMLSerializer().serializeToString(content),
      });
  
      if (response.status != 200)
        return [
          ErrorCode.HTTP_ERROR,
          response.status + " " + response.statusText,
        ];
  
      const text = await response.text();
  
      const source = parseXml(text);
      const nsr = source.createNSResolver(source.documentElement);
  
      let find = source.evaluate(
        "/CRMAcresMessage/Body/Error",
        source.documentElement,
        nsr,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null
      );
      if (find.singleNodeValue !== null) {
        find = source.evaluate(
          "/CRMAcresMessage/Body/Error/ErrorDescription",
          source.documentElement,
          nsr,
          XPathResult.STRING_TYPE,
          find
        );
        return [ErrorCode.REQUEST_FAILED, find.stringValue];
      }
  
      return [ErrorCode.NONE, source];
    }
  
    async getPatronProfile(playerId, fast) {
      const [sourceStatus, source] = await this.#getRequest(
        "/api/PlayerProfile/" + playerId
      );
  
      if (sourceStatus !== ErrorCode.NONE)
        return { status: sourceStatus, result: null, errorDetails: source };
  
      return await this.#parsePatronProfile(source, fast);
    }
  
    async #parsePatronProfile(source, fast) {
      const [resultStatus, result] = this.#getPatronProfileXLST.process(source);
  
      if (!resultStatus) {
        switch (result) {
          case "xml":
            return {
              status: ErrorCode.XML_ERROR,
              result: null,
              errorDetails: null,
            };
          case "json":
            return {
              status: ErrorCode.JSON_ERROR,
              result: null,
              errorDetails: null,
            };
          default:
            return {
              status: ErrorCode.UNKNOWN_ERROR,
              result: null,
              errorDetails: result,
            };
        }
      }
  
      if (!fast) {
        const [tripStatus, tripSource] = await this.#getRequest(
          "/api/TripSummary/" + result.playerId
        );
        if (tripStatus !== ErrorCode.NONE) {
          return {
            status: ErrorCode.PARTIAL_DATA,
            result,
            errorDetails: {
              status: tripStatus,
              result: null,
              errorDetails: tripSource,
            },
          };
        }
  
        const nsr = tripSource.createNSResolver(tripSource.documentElement);
        const pointsEarned = tripSource.evaluate(
          "/CRMAcresMessage/Body/TripSummary/Summary[@SummaryType='CDay']/PointsEarned",
          tripSource.documentElement,
          nsr,
          XPathResult.NUMBER_TYPE,
          null
        );
  
        if (!isNaN(pointsEarned.numberValue))
          result.gamingInfo.pointsEarnedToday = pointsEarned.numberValue;
      }
  
      return { status: ErrorCode.NONE, result, errorDetails: null };
    }
  
    async getPlayerActivity(playerId) {
      const [sourceStatus, source] = await this.#getRequest(
        "/api/TripSummary/" + playerId
      );
  
      if (sourceStatus !== ErrorCode.NONE) {
        return { status: sourceStatus, result: null, errorDetails: source };
      }
  
      const [resultStatus, result] = this.#getPlayerActivityXSLT.process(source);
  
      if (!resultStatus) {
        switch (result) {
          case "xml":
            return {
              status: ErrorCode.XML_ERROR,
              result: null,
              errorDetails: null,
            };
          case "json":
            return {
              status: ErrorCode.JSON_ERROR,
              result: null,
              errorDetails: null,
            };
          default:
            return {
              status: ErrorCode.UNKNOWN_ERROR,
              result: null,
              errorDetails: result,
            };
        }
      }
  
      for (const key in result) {
        if (Object.hasOwnProperty.call(result, key)) {
          const [hour, min] = result[key].timePlayed.split(":", 2);
  
          result[key].timePlayed = {
            hours: Number(hour ?? "0"),
            minutes: Number(min ?? "0"),
          };
        }
      }
  
      return { status: ErrorCode.NONE, result, errorDetails: null };
    }
  
    async getPlayerBalances(playerId) {
      const [sourceStatus, source] = await this.#getRequest(
        "/api/PlayerBalances/" + playerId
      );
  
      if (sourceStatus !== ErrorCode.NONE) {
        return { status: sourceStatus, result: null, errorDetails: source };
      }
  
      const [resultStatus, result] = this.#getPlayerBalancesXSLT.process(source);
  
      if (!resultStatus) {
        switch (result) {
          case "xml":
            return {
              status: ErrorCode.XML_ERROR,
              result: null,
              errorDetails: null,
            };
          case "json":
            return {
              status: ErrorCode.JSON_ERROR,
              result: null,
              errorDetails: null,
            };
          default:
            return {
              status: ErrorCode.UNKNOWN_ERROR,
              result: null,
              errorDetails: result,
            };
        }
      }
  
      return { status: ErrorCode.NONE, result, errorDetails: null };
    }
  
    async updatePlayerProfile(playerId, email, address, phoneNumber) {
      let update = {
        messageId: UniversalConnector.nextMessageId++,
      };
  
      if (email !== undefined) update.email = email;
      if (address !== undefined) update.address = address;
      if (phoneNumber !== undefined) update.phoneNumber = phoneNumber;
  
      update = jsonToXml(update);
  
      const [payloadStatus, payload] = this.#updateProfileXSLT.process(update);
  
      if (!payloadStatus) {
        switch (payload) {
          case "xml":
            return {
              status: ErrorCode.XML_ERROR,
              result: null,
              errorDetails: null,
            };
          default:
            return {
              status: ErrorCode.UNKNOWN_ERROR,
              result: null,
              errorDetails: payload,
            };
        }
      }
  
      const [sourceStatus, source] = await this.#postRequest(
        "/api/PlayerProfile/" + playerId,
        payload
      );
  
      if (sourceStatus !== ErrorCode.NONE)
        return { status: sourceStatus, result: null, errorDetails: source };
  
      return this.#parsePatronProfile(source, true);
    }
  
    #parseBalanceAdjustmentResponse(response) {
      const [resultStatus, result] =
        this.#balanceAdjustmentXSLT.process(response);
  
      if (!resultStatus) {
        switch (result) {
          case "xml":
            return {
              status: ErrorCode.XML_ERROR,
              result: null,
              errorDetails: null,
            };
          case "json":
            return {
              status: ErrorCode.JSON_ERROR,
              result: null,
              errorDetails: null,
            };
          default:
            return {
              status: ErrorCode.UNKNOWN_ERROR,
              result: null,
              errorDetails: result,
            };
        }
      }
  
      return { status: ErrorCode.NONE, result, errorDetails: null };
    }
  
    async doBalanceAdjustment(playerId, balanceType, adjustmentType, value) {
      if (BalanceType[balanceType] === undefined)
        throw "Invalid balanceType argument";
  
      if (
        adjustmentType !== BalanceAdjustimentType.Credit &&
        adjustmentType !== BalanceAdjustimentType.Debit
      )
        throw "Invalid adjustmentType argument";
  
      if (typeof value !== "number" || isNaN(value))
        throw "Invalid value argument";
  
      const update = jsonToXml({
        messageId: UniversalConnector.nextMessageId++,
        balanceType,
        creditType: adjustmentType,
        value,
      });
  
      const [payloadStatus, payload] =
        this.#doBalanceAdjustmentXSLT.process(update);
  
      if (!payloadStatus) {
        switch (payload) {
          case "xml":
            return {
              status: ErrorCode.XML_ERROR,
              result: null,
              errorDetails: null,
            };
          default:
            return {
              status: ErrorCode.UNKNOWN_ERROR,
              result: null,
              errorDetails: payload,
            };
        }
      }
  
      const [sourceStatus, source] = await this.#postRequest(
        "/api/PlayerBalanceAdjustment/" + playerId,
        payload
      );
  
      if (sourceStatus !== ErrorCode.NONE)
        return { status: sourceStatus, result: null, errorDetails: source };
  
      return this.#parseBalanceAdjustmentResponse(source);
    }
  
    updateBalances(balances, adjustmentResponse) {
      switch (adjustmentResponse.balanceType) {
        case BalanceType.Points:
          balances.pointBalance = adjustmentResponse.balances.new;
          break;
        case BalanceType.Comp:
          balances.compBalance = adjustmentResponse.balances.new;
          break;
        case BalanceType.SecondComp:
          balances.secondCompBalance = adjustmentResponse.balances.new;
          break;
        case BalanceType.XtraCredit:
          balances.xtraCreditBalanceLocal = adjustmentResponse.balances.new;
          break;
        default:
          break;
      }
    }
  }
  
  